import React, { useEffect, useState } from 'react';
import { Grid, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

function RecommendUpgradeSubscriptionPopup(props) {
    const history = useHistory();
    const classes = useStyles();


    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        if (props?.setRecommendUpgrade) {
            return props?.setRecommendUpgrade()
        }
    }

    const handleUpdate = () => {
        setOpen(false);
        history.push('/more/subscription-plan')
    }



    useEffect(() => {
        props?.recommend && setOpen(true)
    }, [props?.recommend])

    return (
        <Dialog open={open} onClose={handleClose}  >
            <DialogTitle>
                <Grid container justify="space-between">
                    <Grid item>
                        <Typography component="h4" variant="h5" >
                            Upgrade Subscription?
                        </Typography>
                    </Grid>
                    <Grid item>
                        <IconButton onClick={handleClose}>
                            <Close />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent style={{ display: 'flex', justifyContent: 'center' }}>
                <Typography >
                    {
                        'Would you like to upgrade to get more options and bigger discount?'
                    }
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleUpdate} className={classes.modelBtn} >
                    Upgrade Now
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default RecommendUpgradeSubscriptionPopup;

const useStyles = makeStyles((theme) => ({

    modelBtn: {
        fontFamily: theme.fontFamily.Roboto,
        cursor: "pointer",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "21px",
        textTransform: 'none',
        color: theme.colors.white,
        background: `linear-gradient(#09A9BB 1%,#09A9BB 100%)`
    },

}));